import React, { Component } from "react";
import { Modal as OriginalModal } from 'antd';

class Modal extends Component<any> {
  state = { 
  };
  render() {  
    console.log("00000000",this.props)
    return <OriginalModal {...this.props}
    title="Basic Modal"
    visible={this.props.visible?.modelshow}  />;
  }
};

export default Modal;
